import { Injectable, signal } from '@angular/core';

export interface ToastConfig {
  message: string;
  type: 'success' | 'error' | 'info';
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toast = signal<ToastConfig | null>(null);

  show(config: ToastConfig): void {
    this.toast.set(config);
  }

  success(message: string, duration = 5000): void {
    this.show({ message, type: 'success', duration });
  }

  error(message: string, duration = 5000): void {
    this.show({ message, type: 'error', duration });
  }

  info(message: string, duration = 5000): void {
    this.show({ message, type: 'info', duration });
  }
}
